import { apiClient } from './client';
import { formatShortDate } from '../utils/datetime';

export async function getOverview() {
  const { data } = await apiClient.get('/stats/overview');
  return data;
}

/**
 * Revenue totals for a period. This is an object, not a list:
 * { totalRevenue, periodRevenue, averageOrderValue, totalOrders, completedOrders, refundedOrders,
 *   revenueByProvider: [{ provider, total }], revenueByDay: [{ date: 'YYYY-MM-DD', amount }] }
 * @param {{ period?: '7d'|'30d'|'90d'|'1y' }} params
 */
export async function getRevenueStats(params = {}) {
  const { data } = await apiClient.get('/stats/revenue', { params });
  return data;
}

/**
 * The revenueByDay series of a getRevenueStats() result as chart points
 * [{ name: '3-okt', value }] (the label follows the UI language), oldest day first.
 */
export function revenueSeries(stats) {
  return (stats?.revenueByDay || []).map((day) => ({
    // The date is a UTC calendar day: datetime.js reads "YYYY-MM-DD" as that day, so the label
    // cannot slip a day west of UTC
    name: formatShortDate(day.date),
    value: Number(day.amount) || 0,
  }));
}

export async function getUserStats(params = {}) {
  const { data } = await apiClient.get('/stats/users', { params });
  return data;
}

export async function getCourseStats(params = {}) {
  const { data } = await apiClient.get('/stats/courses', { params });
  return data;
}

export async function getEngagementStats(params = {}) {
  const { data } = await apiClient.get('/stats/engagement', { params });
  return data;
}
